export default "__VITE_ASSET__a5b80c49__"